<template>
    <div>
        <veui-dialog
            :open.sync="modalOpen"
            :closable="false"
            :footless="true"
        >
            <div
                v-visually="{
                    serverId: 19814,
                    area: 'zxlltstc',
                    isNotRepeat: true,
                    ext: {
                        action: 'show',
                    },
                }"
                class="container"
            >
                <veui-icon
                    name="times"
                    class="close-icon"
                    @click.native="handleClose"
                />
                <div class="header">
                    <div class="title">咨询流量提升攻略</div>
                    <div class="sub-title">同时做到以下两点，流量扶持效果最佳</div>
                </div>
                <div class="content">
                    <div class="way-content">
                        <div class="title">方法一：{{ wayOneText }}</div>
                        <div class="detail-box">
                            <img class="crown-bg" src="https://lvlin-fe-saas.cdn.bcebos.com/components/biz/consult-improve-dialog/crown-bg.png">
                            <div class="left-box">
                                <div class="identity">当前身份: {{ vipTypeText.replace('-7天后过期', '') }}</div>
                                <div class="tip">{{ tipText }}</div>
                            </div>
                            <div
                                :class="['right-box', '您已是最高等级会员' === btnText && 'disabled']"
                                @click="authorize('您已是最高等级会员' === btnText)"
                            >
                                {{ btnText }}
                            </div>
                        </div>
                    </div>
                    <div class="way-content">
                        <div class="title">方法二：{{ businessLevelTextMap[level]?.methodText ?? '提升经营等级' }}</div>
                        <div class="detail-box">
                            <img class="vip-bg" src="https://lvlin-fe-saas.cdn.bcebos.com/components/biz/consult-improve-dialog/vip-bg.png">
                            <div class="left-box">
                                <div class="identity">当前等级：V{{ level }}</div>
                                <div class="tip">
                                    {{ businessLevelTextMap[level]?.tipText ?? '完成任务提升等级，额外免费享受专属权益' }}
                                </div>
                            </div>
                            <div class="right-box" @click="gotoBusinessCenter">
                                {{ businessLevelTextMap[level]?.btnText ?? '立即完成任务，解锁权益' }}
                            </div>
                        </div>
                    </div>
                </div>
                <div class="footer">
                    <div class="footer-btn" @click="handleKnow">我知道了</div>
                </div>
            </div>
        </veui-dialog>
        <vip-authorize-modal
            :show="isAuthorizeShow"
            :authorized="true"
            @cancel="isAuthorizeShow = false"
        />
    </div>
</template>

<script>
import {Icon, Dialog} from 'veui';
import {mapState} from 'vuex';
import {vipCodeTypeMap, newVipCodeTypeMap} from '@/config/vipInfo';
import {vipCodeTypeTextMap, businessLevelTextMap} from './config';
import {getBusinessLevelInfo} from '@/request/businessLevel';
import {authorizeVip} from '@/request/vip';
import VipAuthorizeModal from '@/components/vip/vip-authorize-modal';

export default {
    name: 'ConsultImproveDialog',

    components: {
        VipAuthorizeModal,
        VeuiIcon: Icon,
        VeuiDialog: Dialog
    },

    data() {
        return {
            businessLevelTextMap,
            modalOpen: true,
            isAuthorizeShow: false,
            level: 0
        };
    },

    computed: {
        ...mapState({
            vipInfo: state => state.lawStore?.vipInfo
        }),

        // 是否是会员
        isVip() {
            return this.vipInfo.vipStatus !== '0';
        },

        // 是否是旧会员
        isOldVip() {
            return this.vipInfo.old_vip_code === 1;
        },

        // 会员类型文本
        vipTypeText() {
            if (!this.isVip) {
                return '非会员律师';
            }

            const vipCodeMap = this.isOldVip ? vipCodeTypeMap : newVipCodeTypeMap;
            const vipType = vipCodeMap[this.vipInfo.privilege_info.vip_code_type];

            const {validityEnd} = this.vipInfo;
            const validityEndTime = new Date(validityEnd).getTime(); // 会员到期时间
            const nowTime = Date.now();
            const sevenDayTime = 7 * 1000 * 60 * 60 * 24;

            // 会员七天到期
            if (['卓越版会员', '精英会员', '尊享会员'].includes(vipType) && validityEndTime - nowTime <= sevenDayTime) {
                return `${vipType}-7天后过期`;
            }
            return vipType;
        },

        // 方法一文案
        wayOneText() {
            return vipCodeTypeTextMap[this.vipTypeText]?.methodText;
        },

        // 会员提示文案
        tipText() {
            return vipCodeTypeTextMap[this.vipTypeText]?.tipText;
        },

        // 会员按钮文案
        btnText() {
            return vipCodeTypeTextMap[this.vipTypeText]?.btnText;
        }
    },

    watch: {
        modalOpen: {
            handler(val) {
                if (val) {
                    this.$wywLog.send({
                        serverId: 19814,
                        area: 'hysf',
                        action: 'show',
                        index: this.vipTypeText,
                        isOldVip: this.isOldVip ? 1 : 0
                    });
                    this.$wywLog.send({
                        serverId: 19814,
                        area: 'jysf',
                        action: 'show',
                        index: this.level
                    });
                }
            },
            immediate: true
        }
    },

    mounted() {
        this.getBusinessLevelInfo();
    },

    methods: {
        // 获取经营等级
        async getBusinessLevelInfo() {
            const res = await getBusinessLevelInfo();
            this.level = res.data.level ?? 0;
        },

        // 弹窗显示切换
        changeModalOpen(open) {
            this.modalOpen = open;
        },

        // 联系客服授权 vip
        async authorize(disabled) {
            if (disabled) {
                return;
            }

            try {
                this.changeModalOpen(false);
                const res = await authorizeVip();
                if (res.code === '0') {
                    this.isAuthorizeShow = true;
                }
                else {
                    this.$toast.error('提交失败，请稍后再试～');
                }
            }
            catch (error) {
                this.$toast.error('授权失败，请稍后再试～');
            }
            finally {
                this.$wywLog.send({
                    serverId: 19814,
                    area: 'hysf-sqkfdl-btn',
                    action: 'click',
                    index: this.vipTypeText,
                    isOldVip: this.isOldVip ? 1 : 0
                });
            }
        },

        // 跳转经营中心
        gotoBusinessCenter() {
            this.$wywLog.send({
                serverId: 19814,
                area: 'jysf-ck-btn',
                action: 'click',
                index: this.level
            });
            this.$router.push({
                name: 'businessCenter',
                query: {fr: '1v1zx-ckxq'}
            });
        },

        // 我知道了
        handleKnow() {
            this.changeModalOpen(false);
            this.$wywLog.send({
                serverId: 19814,
                area: 'wzdl-btn',
                action: 'click',
                index: this.level
            });
        },

        // 点击关闭按钮
        handleClose() {
            this.changeModalOpen(false);
            this.$wywLog.send({
                serverId: 19814,
                area: 'close-btn',
                action: 'click',
                index: this.level
            });
        }
    }
};
</script>

<style lang="less" scoped>
::v-deep .veui-dialog-content {
    width: 714px;
    height: 600px;
    padding: 30px;

    .veui-dialog-content-head {
        display: none;
    }

    .veui-dialog-content-body {
        padding: 0;
    }
}

.container {
    position: relative;

    .close-icon {
        position: absolute;
        right: 0;
        cursor: pointer;
        z-index: 1;
    }

    .header {
        display: flex;
        flex-direction: column;
        align-items: center;

        .title {
            font-family: "Alibaba PuHuiTi 2.0";
            font-size: 30px;
            font-style: normal;
            font-weight: 900;
            line-height: 30px;
            background: linear-gradient(135deg, #0057e5 .28%, #2253e5 50.14%, #6135e5 100%);
            background-clip: text;
            color: transparent;
        }

        .sub-title {
            margin-top: 12px;
            color: #00225c;
            font-family: "PingFang SC";
            font-size: 18px;
            font-style: normal;
            font-weight: 400;
            line-height: 18px;
            opacity: .5;
        }
    }

    .content {
        margin-top: 24px;

        .way-content {
            &:not(:first-child) {
                margin-top: 24px;
            }

            .title {
                margin-left: 22px;
                color: #1a6eff;
                font-family: "PingFang SC";
                font-style: normal;
                font-size: 20px;
                font-weight: 500;
                line-height: 24px;
            }

            .detail-box {
                display: flex;
                position: relative;
                justify-content: space-between;
                align-items: center;
                margin-top: 12px;
                padding-left: 22px;
                padding-right: 24px;
                height: 148px;
                border-radius: 15px;
                border: 1.2px solid #dae7fb;
                background: linear-gradient(90deg, #e4f2ff 0%, #fff 100%);

                .crown-bg,
                .vip-bg {
                    position: absolute;
                    right: 24px;
                    height: 100%;
                }

                .left-box {
                    .identity {
                        color: #0a0b0d;
                        font-family: "PingFang SC";
                        font-size: 20px;
                        font-style: normal;
                        font-weight: 500;
                        line-height: 20px;
                    }

                    .tip {
                        position: relative;
                        max-width: 435px;
                        margin-top: 21px;
                        color: #00225c;
                        font-family: "PingFang SC";
                        font-size: 18px;
                        font-style: normal;
                        font-weight: 400;
                        line-height: 28px;
                        z-index: 1;
                    }
                }

                .right-box {
                    position: relative;
                    padding: 8px 16px;
                    border-radius: 6px;
                    background: #0054e6;
                    color: #fff;
                    font-family: "PingFang SC";
                    font-size: 16px;
                    font-style: normal;
                    font-weight: 400;
                    line-height: 24px;
                    z-index: 1;
                    cursor: pointer;

                    &.disabled {
                        background: #b3ccff;
                    }
                }
            }
        }
    }

    .footer {
        display: flex;
        justify-content: center;
        margin-top: 24px;

        .footer-btn {
            display: flex;
            justify-content: center;
            align-items: center;
            width: 190px;
            height: 40px;
            border-radius: 6px;
            background: #f6f7fa;
            color: #00225c;
            font-family: "PingFang SC";
            font-size: 16px;
            font-style: normal;
            font-weight: 500;
            line-height: normal;
            cursor: pointer;
        }
    }
}
</style>